module.exports = __webpack_public_path__ + "static/media/cloud.98e27eab.svg";